<template>
  <div class="dataLayout">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
      
  </div>
</template>

<script>
export default {
  name: 'dataLayout',
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){




  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.dataLayout{
  position: relative;
  width: 100%;
  height: 100%;
}
</style>